import { render } from "./Guinevere.vue?vue&type=template&id=0ba99445&scoped=true&ts=true"
import script from "./Guinevere.vue?vue&type=script&lang=ts"
export * from "./Guinevere.vue?vue&type=script&lang=ts"

import "./Guinevere.vue?vue&type=style&index=0&id=0ba99445&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba99445"]])

export default __exports__